export default __webpack_public_path__ + "static/media/customer-opal.195862e6.jpg";